/**
 * LABS: Pippi's panel, bubble and banner load only for people on the pilot: this tiny gate stays in the main bundle,
 * the rest (PippiRoot and the markdown, thread and case views behind it) is a separate chunk fetched once cowork says
 * `available`. The capture code (recorder, timeline, ears) is a further chunk, loaded on the first recording.
 */
import { lazy, Suspense } from 'react';
import { usePippi } from './pippiHooks';

const PippiRoot = lazy(() => import('./PippiRoot').then((m) => ({ default: m.PippiRoot })));

export function PippiRootGate({ railOpen = false }: { railOpen?: boolean }) {
  const p = usePippi();
  if (!p?.available) return null;
  return <Suspense fallback={null}><PippiRoot railOpen={railOpen} /></Suspense>;
}
